import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AppState {
  sidebarCollapsed: boolean;
  theme: 'dark' | 'light';
  selectedAccountId: string | null;
  toggleSidebar: () => void;
  setTheme: (t: 'dark' | 'light') => void;
  setSelectedAccountId: (id: string | null) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      theme: 'dark',
      selectedAccountId: null,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setTheme: (theme) => set({ theme }),
      setSelectedAccountId: (selectedAccountId) => set({ selectedAccountId }),
    }),
    { name: 'journal-app' }
  )
);
